'use strict';

var React = require('react');

var SvgAppsMajor = function SvgAppsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h-8v-6.5a1.5 1.5 0 0 1 1.5-1.5h6.5v8zm0 2v8h-6.5a1.5 1.5 0 0 1-1.5-1.5v-6.5h8zm2 0v8h6.5a1.5 1.5 0 0 0 1.5-1.5v-6.5h-8zm4-10a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1z"
  }));
};

exports.SvgAppsMajor = SvgAppsMajor;
